<template>
  <v-container fluid class="pa-0">
    <app-header inside :numbers="!!number" :button="!number" :buttonAction="action">
      <template v-slot:title>{{ data.name }}</template>
      <template v-if="number" #current-step>{{ number }}</template>
      <template v-if="maxStep" #max-step>{{ maxStep }}</template>
      <template #buttonText>{{ number === maxStep ? "Next Step >>" : "Next Exercise" }}</template>
    </app-header>
    <v-divider class="my-3"></v-divider>
    <app-focus
      @next-exercise="action"
      :button="number > 0"
      :backButton="$route.name !== 'exercise'"
      :backAction="backAction"
    >
      <template #title-focus>Exercise Focus:</template>
      <template #buttonText>{{ number === maxStep ? "Next Step >>" : "Next Exercise" }}</template>
      <template #normal-text>{{ data.focus }}</template>
    </app-focus>
    <app-title>
      <template #title>Directions</template>
      <template #text>{{ data.description }}</template>
    </app-title>
    <app-pictures-body
      :stepUuid="data.uuid"
      @finished="onFinished"
      @already-finished="onAlreadyFinished"
      class="mt-10 pt-2"
      :questions="data.question_group.questions"
      :question_group="data.question_group.uuid"
      @reset="$emit('reset')"
    ></app-pictures-body>
  </v-container>
</template>
<script>
import Header from "./../components/Header.vue";
import Focus from "./Focus.vue";
import Title from "./Title.vue";
import PicturesBody from "./Pictures/PicturesBody.vue";
import finishMixin from "@/mixins/finishMixin";

export default {
  components: {
    appHeader: Header,
    appFocus: Focus,
    appTitle: Title,
    appPicturesBody: PicturesBody,
  },
  mixins: [finishMixin],
  props: {
    data: {
      required: false,
      default: () => {},
      type: Object,
    },
    number: {
      required: false,
      default: 0,
      type: Number,
    },
    maxStep: {
      required: false,
      default: -1,
      type: Number,
    },
  },
  methods: {
    action() {
      this.$emit("next-exercise");
    },
    backAction() {
      this.$emit("prev-exercise");
    },
  },
  data() {
    return {
      finished: false,
    };
  },
};
</script>
